import { FC } from 'react';
import Page, { PageProps } from '../../components/page';
import { createUseStyles } from 'react-jss';
import RecentTileGroup from './recent-tile-group';
import FavoritesTileGroup from './favorites-tile-group';
import AllTileGroup from './all-tile-group';
import { HomeProvider } from '@/contexts/home';
import useHome from '@/hooks/use-home.hook';
import PageContent from '@/components/page/content';

const useStyles = createUseStyles({
  homePage: {
    overflowY: 'auto',
  },
});

const HomePage: FC<PageProps> = (props) => {
  return (
    <HomeProvider>
      <HomePageWithContext {...props} />
    </HomeProvider>
  );
};

const HomePageWithContext: FC<PageProps> = () => {
  const styles = useStyles();
  const { hasFavorites, hasRecent, isLoading } = useHome();

  if (isLoading) {
    return null;
  }

  return (
    <Page className={styles.homePage} title="Home">
      <PageContent>
        {hasRecent && <RecentTileGroup />}

        {hasFavorites && <FavoritesTileGroup />}

        <AllTileGroup />
      </PageContent>
    </Page>
  );
};

export default HomePage;
